import {Injectable} from "@angular/core";
import {JwtHelperService} from "@auth0/angular-jwt";
import {JwtToken} from "../models/jwt.model";

@Injectable({
  providedIn: 'root'
})
export class TokenManagerService {
  constructor(private jwtHelper: JwtHelperService) { }

  public getToken(): JwtToken {
    const token = localStorage.getItem('token');
    if (token) return this.jwtHelper.decodeToken(token) as JwtToken;
    return {} as JwtToken;
  }

  public setToken(token: string) {
    this.removeToken();
    localStorage.setItem('token', token);
  }

  public removeToken() {
    localStorage.removeItem('token');
  }

  public getRefreshToken(): string | null {
    return localStorage.getItem('refresh');
  }

  public setRefreshToken(token: string) {
    this.removeRefreshToken();
    localStorage.setItem('refresh', token);
  }

  public removeRefreshToken() {
    localStorage.removeItem('refresh');
  }

  clearStorage() {
    this.removeToken();
    this.removeRefreshToken()
  }

  public isTokenExpired(): boolean {
    const token = localStorage.getItem('token');
    return this.jwtHelper.isTokenExpired(token);
  }
}
